import React from 'react';
import IcArrowRight from '@/assets/icons/ic-arrow-right.svg';

interface DashboardActionCardProps {
    title: string;
    subtitle: string;
    image: string;
    onClick: () => void;
}

export function DashboardActionCard({ title, subtitle, image, onClick }: DashboardActionCardProps) {
    return (
        <button
            onClick={onClick}
            className='group bg-neutral-white shadow-brand hover:border-primary-main mt-2 flex h-24 w-full cursor-pointer items-center justify-between rounded-md border border-transparent p-4 text-left transition-all hover:scale-105'
        >
            <div className='flex-1'>
                <div className='mb-2 flex items-center'>
                    <h4 className='text-primary-main w-fit'>{title}</h4>
                    <IcArrowRight className='text-primary-main size-5 transition-transform group-hover:translate-x-1' />
                </div>
                <p className='text-gray text-sm'>{subtitle}</p>
            </div>
            <div className='ml-4 flex-shrink-0'>
                <div className='flex size-20 items-center justify-center overflow-hidden rounded-md'>
                    <img src={image} alt={title} className='size-full object-cover' />
                </div>
            </div>
        </button>
    );
}
